import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "78d8860e-f9bd-424a-932f-dec0ee6046b6",
    content: "Answer A",
    options: { image: `${config.ASSETS_URL}/05/28/task/task-2-a.svg` },
  },
  {
    id: "3060459f-0731-4f71-a7c7-35eaf8903d11",
    content: "Answer B",
    options: { image: `${config.ASSETS_URL}/05/28/task/task-2-b.svg` },
  },
  {
    id: "0ffdf5e2-47c6-4f66-af18-dae7bb249855",
    content: "Answer C",
    options: { image: `${config.ASSETS_URL}/05/28/task/task-2-c.svg` },
  },
  {
    id: "7b089240-06b8-45b7-a941-1019b60473f1",
    content: "Answer D",
    options: { image: `${config.ASSETS_URL}/05/28/task/task-2-d.svg` },
  },
];

export const task: Task = {
  id: "31dbc2f9-1613-4368-90ad-67aed2677d52",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
    imageHeight: 150,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["7b089240-06b8-45b7-a941-1019b60473f1"],
};
